<template>
  <div class="page-content">
    <el-row class="operation">
      <div class="left">
        <el-input v-model="listQuery.productName" placeholder="请输入产品名称" style="width: 150px;" clearable @clear="searchHandle"></el-input>
        <el-select v-model="listQuery.isEnable" @change="searchHandle
        " placeholder="请选择产品状态">
          <el-option v-for="item in statusOpts" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" @click="searchHandle">查询</el-button>
        <el-button @click="toAddPage" type="primary">添加引导页</el-button>
      </div>
      <div class="right">
        
      </div>
    </el-row>
    <!-- 数据展示区域 -->
    <el-row class="dataList">
      <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" :cell-style="acellStyle" :height="tableHeight"
        :header-cell-style="headCellStyle" style="width: 100%">
        <el-table-column prop="productName" label="产品名称">
        </el-table-column>
        <el-table-column prop="productKey" label="productKey">
        </el-table-column>
        <el-table-column prop="addType" label="添加方式">
          <template slot-scope="scope">
            {{ scope.row.addType === 0 ? 'DLNA' : scope.row.addType === 1 ? '自发现方式' : scope.row.addType === 2 ? '短按入网键方式' :
              scope.row.addType === 3 ? '二维码' : scope.row.addType === 4 ? '云云对接' : 'Auth2.0对接' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" @click="handlerViewClick(scope.row, 'view')"> 查看</el-button>
              <el-button type="danger" size="mini" @click="handlerViewClick(scope.row, 'del')"> 删除</el-button>
              <el-button type="success" size="mini" @click="handlerViewClick(scope.row, 'use')"
                v-if="scope.row.isEnable === '1'"> 启用</el-button>
              <el-button type="warning" size="mini" @click="handlerViewClick(scope.row, 'stop')"
                v-if="scope.row.isEnable === '0'"> 禁用</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <Paging :total="total" @changePage="changePage" />
  </div>
</template>
<script>
import { mixin } from '@/mixins/mixin.js'
import Paging from '@/components/paging'
import { guideList, isUse, isDel } from '@/api/appGuide'
export default {
  mixins: [mixin],
  components: {
    Paging
  },
  data() {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        productName: '',
        isEnable: 0
      },
      statusOpts: [{
        value: 0,
        label: '启用'
      }, {
        value: 1,
        label: '禁用'
      }],
      tableData: [],
      tableHeight: 600,
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' }
    }
  },
  created() {
    this.getGuideList();

    this.getAutoHeight();
    let that = this;
    window.onresize = function () {
      that.getAutoHeight();
    };
  },
  methods: {
    getAutoHeight() {
      debugger;
      this.tableHeight = document.documentElement.clientHeight - 300;
    },
    searchHandle() {
      this.listQuery.pageNumber = 1;
      this.getGuideList();
    },
    getGuideList() {
      guideList({ params: this.listQuery }).then((res) => {
        let {list, total} = res.data.data;
        this.tableData = list
        this.total = total
      })
    },
    handleChange(row) {
      const params = {
        id: row.guideId,
        isDelete: row.isUsed
      }
      isUse({ params }).then((res) => {
        this.getGuideList()
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        }
      }).catch(() => {
        // row.isUsed = !row.isUsed
        row.isUsed = ~row.isUsed + 2
      })
    },
    handlerViewClick(row, val) {
      const obj = {
        guideId: row.guideId,
        desc: 'view'
      }
      const params = {
        id: row.guideId,
        isDelete: 1
      }
      switch (val) {
        case 'view':
          obj.guideIdOrProductKey = row.guideId;
          this.$router.push({
            path: '/categoryManager/addAppGuide',
            query: {
              obj: JSON.stringify(obj)
            }
          })
          break
        case 'del':
          params.isDelete = 1
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'error'
          }).then(() => {
            let params = {
              guideIdOrProductKey: row.guideId
            }
            isDel({ params }).then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.cutPage()
                this.getGuideList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
          break
        case 'use':
          params.isDelete = 0
          isUse({ params }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '启用成功'
              })
              this.getGuideList()
            }
          })
          break
        case 'stop':
          params.isDelete = 1
          isUse({ params }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '禁用成功'
              })
              this.getGuideList()
            }
          })
          break
      }
    },
    toAddPage() {
      const obj = {
        desc: 'add'
      }
      this.$router.push({
        path: '/categoryManager/addAppGuide',
        query: {
          obj: JSON.stringify(obj)
        }
      })
    },
    // 分页管理
    changePage(val) {
      let {limit: pageSize, page: pageNumber} = val;
      this.listQuery.pageSize = pageSize;
      this.listQuery.pageNumber = pageNumber;
      this.getGuideList()
    }
  }
}
</script>

<style lang='less' scoped>
.operation {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;

  .left {
    flex: 1;
  }

  .right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
